import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import { redirectNewCampaignsToEngageBuilderV2, requireEngagePermission } from '../auth/routerHooks';
import BackButton from './components/BackButton';
import ViewCampaign from './containers/ViewCampaign';
import Layout from './containers/Layout';
import { ListLayout } from '../../modules/shared/engage/campaign-list/list-layout';
import withNewDesignStyles from '../common/hoc/withNewDesignStyles';
import CampaignDraft from './containers/CampaignDraft';
import DraftActions from './components/DraftActions';
import PayCampaign from './containers/PayCampaign';
import CampaignPayActions from './containers/CampaignPayActions';
import { CampaignList } from '../../modules/shared/engage/campaign-list';
import { EngageHeaderControls } from '../../modules/shared/engage/campaign-list/header-controls';
import withoutPageHeader from '../common/hoc/withoutPageHeader';
import { AutomatedListView } from '../../modules/shared/engage/automated/automated-list-view';

const createTitle = (text) => <span data-automation-id="text:header">{text}</span>;

const Routes = (store) => (
  <>
    <Route
      path="engagement/automated"
      component={withoutPageHeader(ListLayout)}
      onEnter={requireEngagePermission(store)}
    >
      <IndexRoute
        components={{
          children: AutomatedListView,
        }}
      />
    </Route>

    <Route path="engagement" component={withNewDesignStyles(Layout)} onEnter={requireEngagePermission(store)}>
      <IndexRoute
        components={{
          title: () => createTitle('Engage'),
          controls: EngageHeaderControls,
          content: CampaignList,
        }}
      />
      <Route
        path="new"
        components={{ title: () => createTitle('Engage Clients'), controls: DraftActions, content: CampaignDraft }}
        onEnter={redirectNewCampaignsToEngageBuilderV2()}
      />
      <Route
        path=":campaignId"
        components={{ title: () => createTitle('Engage Clients'), controls: DraftActions, content: CampaignDraft }}
      />
      <Route
        path=":campaignId/view"
        components={{
          title: () => createTitle('Engage Clients'),
          controls: () => <BackButton to="/engagement" />,
          content: ViewCampaign,
        }}
      />
      <Route
        path=":campaignId/charge"
        components={{ title: () => createTitle('Engage Clients'), controls: CampaignPayActions, content: PayCampaign }}
      />
    </Route>
  </>
);

export default Routes;
